import { useState } from "react";
import { useAtom } from "jotai";
import { anioFiltroAtom } from "../DescansoMedicoStore";
import { HistoricoDescansoMedicoService } from "services/VacacionesService";
import useListarHistoricoDescansoMedico from "./useListarHistoricoDescansoMedico";

const useCargarHistoricoDescansoMedico = () => {
  const [archivo, setArchivo] = useState(undefined);
  const [fileList, setFileList] = useState([]);
  const [mensajeExito, setMensajeExito] = useState(undefined);
  const [mensajeError, setMensajeError] = useState(undefined);
  const [cargando, setCargando] = useState(false);
  const [anioFiltro] = useAtom(anioFiltroAtom);
  const { listar } = useListarHistoricoDescansoMedico();

  const cargar = async () => {
    if (!archivo) {
      setMensajeError("Selecciona un archivo Excel antes de continuar.");
      return;
    }
    try {
      setCargando(true);
      setMensajeExito(undefined);
      setMensajeError(undefined);
      const respuesta = await HistoricoDescansoMedicoService.cargar(archivo);
      if (respuesta.estado === "EXITO") {
        setMensajeExito("Histórico cargado correctamente. Cierre la ventana para ver los datos.");
        setArchivo(undefined);
        setFileList([]);
        listar(anioFiltro);
      } else {
        setMensajeError(respuesta.mensaje);
      }
    } catch (error) {
      setMensajeError("Ocurrió un error al cargar el histórico.");
      console.error(error);
    } finally {
      setCargando(false);
    }
  };

  return { archivo, setArchivo, fileList, setFileList, cargar, cargando, mensajeExito, mensajeError };
};

export default useCargarHistoricoDescansoMedico;
